<template>
  <div :class="wrapperClasses">
    <div :class="[addTabsWrapperClasses, gridClasses.content]">
      <BDistributor
        :class="tabsClasses" 
        :addClasses="addTabClasses"
      >
        <slot></slot>
      </BDistributor>
    </div>
    <div :class="navWrapperClasses" style="position: fixed;
    bottom: 0;
    background-color: white;
    width: 100%;
    z-index: 1000;
    height: 80px;">
      <BDistributor
          tag="ul"
          :class="navClasses"
          :header="true"
          :changeTabTo="changeTabTo"
      >
        <slot></slot>
      </BDistributor>
    </div>

  </div>
</template>

<script>
import BDistributor from './BDistributor'

export default {
  name: 'BTabs',
  components: {
    BDistributor
  },
  provide () {
    const tabs = {}
    Object.defineProperty(tabs, 'activeTab', {
      get: () => this.activeTabIndex
    })
    Object.defineProperty(tabs, 'fade', {
      get: () => this.fade
    })
    return { tabs, initialTab: this.activeTab }
  },
  props: {
    fill: Boolean,
    justified: Boolean,
    variant: {
      type: String,
      default: 'tabs',
      validator: val => ['', 'tabs', 'pills'].includes(val)
    },
    fade: {
      type: Boolean,
      default: true
    },
    vertical: [Boolean, Object],
    addNavWrapperClasses: [String, Array, Object],
    addNavClasses: [String, Array, Object],
    addTabsWrapperClasses: [String, Array, Object],
    addTabsClasses: [String, Array, Object],
    addTabClasses: [String, Array, Object],
    activeTab: Number
  },
  data () {
    return {
      activeTabIndex: this.activeTab || 0
    }
  },
  watch: {
    activeTab (val) {
      this.activeTabIndex = val || 0
    }
  },
  computed: {
    wrapperClasses () {
      return { 'row no-gutters': this.vertical }
    },
    navWrapperClasses () {
      return [ this.addNavWrapperClasses, this.gridClasses.navs]
    },
    navClasses () {
      return [
        this.addNavClasses,
        {
          'nav': true,
          'nav-tabs2': this.variant === 'tabs',
          'nav-pills': this.variant === 'pills',
          'flex-column': this.vertical,
          'nav-fill': this.fill,
          'nav-justified': this.justified,
          'h-100': this.vertical
        }
      ]
    },
    tabsClasses () {
      return [
        this.addTabsClasses,
        'tab-content',
        {
          'pl-3 p-0': this.vertical
        }
      ]
    },
    gridClasses () {
      if (this.vertical === true) {
        return { navs: 'col-sm-4', content: 'col-sm-8'}
      } else {
        return this.vertical || {}
      }
    }
  },
  methods: {
    changeTabTo (tab) {
      this.activeTabIndex = tab
      this.$emit('update:activeTab', tab)
    }
  }
}
</script>
<style>
.nav-tabs2 {
  border-bottom: 0px solid;
  border-top: 1px solid;
  border-color: #c4c9d0;
}
.nav-tabs2 .nav-link.active, .nav-tabs .nav-item.show .nav-link {
  color: #768192;
  background-color: #ebedef;
  border-color: #c4c9d0 #c4c9d0 #ebedef;
}
.nav-tabs2 .nav-link {
  border: 1px solid transparent;
  border-bottom-left-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.nav-tabs2 .nav-item {
  margin-top: -1px;
}
</style>

